import { Plus, Trash2 } from 'lucide-react';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';
import { Button } from '@/shared/ui/button';

interface PublicInviteChildrenGroupProps {
  names: string[];
  onChange: (names: string[]) => void;
}

/**
 * "Dados da Criança" repetível (circus) — legado permite N filhos via
 * botões +/- (views/invite_circus.ejs). Só o nome é funcional no legado: o
 * campo de nascimento por filho compartilha o mesmo `name="nameFilho[]"` do
 * nome (bug de copy-paste no template), então o valor nunca chega separado
 * no backend — não replicamos esse campo quebrado, só o nome.
 */
export function PublicInviteChildrenGroup({ names, onChange }: PublicInviteChildrenGroupProps) {
  const setName = (index: number, value: string) =>
    onChange(names.map((c, i) => (i === index ? value : c)));
  const add = () => onChange([...names, '']);
  const remove = (index: number) => onChange(names.filter((_, i) => i !== index));

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">Dados da Criança</h3>
      {names.map((name, index) => (
        <div key={index} className="flex items-end gap-2">
          <div className="flex-1 space-y-2">
            <Label htmlFor={`invite-child-${index}`}>Nome da Criança</Label>
            <Input
              id={`invite-child-${index}`}
              placeholder="Preencha o nome"
              value={name}
              onChange={(e) => setName(index, e.target.value)}
            />
          </div>
          {names.length > 1 ? (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="text-destructive"
              onClick={() => remove(index)}
              aria-label="Remover criança"
            >
              <Trash2 className="size-4" />
            </Button>
          ) : null}
        </div>
      ))}
      <Button type="button" variant="secondary" size="sm" onClick={add}>
        <Plus className="size-4" /> Adicionar criança
      </Button>
    </div>
  );
}
